<template>
    <div>
        <PageHeader :title="'Gerenciamento de Clientes'">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" class="page-header-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            </template>
        </PageHeader>

        <ActionArea>
            <div class="flex flex-wrap items-center justify-between gap-3 w-full">
                <BackButton :to="{ name: 'companies' }" />
                <div class="flex flex-wrap items-center justify-end gap-2">
                    <button type="button" class="company-anchor-button" @click="scrollToSection('company-dados')">Dados</button>
                    <button type="button" class="company-anchor-button" @click="scrollToSection('company-colaboradores')">Colaboradores</button>
                    <button type="button" class="company-anchor-button" @click="scrollToSection('company-setores')">Setores e agrupamentos</button>
                    <button type="button" class="company-anchor-button" @click="scrollToSection('company-usuarios')">Usuários com acesso ao portal</button>
                </div>
            </div>
        </ActionArea>

        <div class="flex justify-center mb-6" v-if="loading">
            <Loading text="Buscando Dados  Aguarde..." :show="loading" />
        </div>

        <div class="grid grid-cols-1" v-if="!loading">
            <form @submit.prevent="submit" novalidate>
                <div class="company-main-card">
                    <div class="bg-white border border-gray-200 border-b-0 rounded-t-md px-6 py-4">
                        <h2 class="text-2xl font-bold uppercase text-gray-600">{{ company.name || 'Adicionar novo cliente' }}</h2>
                    </div>
                    <div id="company-dados">
                    <BaseFormContainer :compact="true">
                        <template v-slot:form>
                            <div class="grid grid-cols-2 gap-x-8 gap-y-6 company-form-grid">
                            <div>
                                <BaseFormSectionHeader title="Informações Básicas" subtitle="Dados da empresa / Cliente"></BaseFormSectionHeader>
                                <div class="grid grid-cols-2 form-row">
                                    <div>
                                        <BaseInput :is-invalid="v$.name.$error" label="Nome da Empresa" @blur="v$.name.$touch" placeholder="Empresa XYZ" v-model="company.name" :required="true" />
                                        <div v-for="error in v$.$errors" :key="error.$uid">
                                            <BaseErrorMessage v-if="error.$property === 'name'" :message="error.$message" />
                                        </div>
                                    </div>
                                    <div>
                                        <BaseInput label="Email 1" placeholder="empresaxyz@empresa.com" v-model="company.email" />
                                    </div>
                                </div>
                                <div class="grid grid-cols-2 form-row">
                                    <div>
                                        <BaseInput label="Email 2" placeholder="empresaxyz2@empresa.com" v-model="company.email2" />
                                    </div>
                                    <div>
                                        <BaseInput label="Telefone" placeholder="" v-model="company.phone" v-maska="MaskService['phone']"  />
                                    </div>
                                </div>
                                <div class="grid grid-cols-2 form-row">
                                    <div>
                                        <BaseInput label="Whatsapp" placeholder="" v-model="company.whatsapp" v-maska="MaskService['phone']"  />
                                    </div>
                                    <div>
                                        <BaseInput label="CNPJ/CPF" placeholder="" v-model="company.cpf" v-maska="MaskService['document']"  />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <BaseFormSectionHeader title="Endereço" subtitle="Dados adicionais"></BaseFormSectionHeader>
                                <div class="grid grid-cols-3 form-row">
                                    <div class="col-span-2">
                                        <BaseInput label="Endereço" placeholder="" v-model="company.address" />
                                    </div>
                                    <div>
                                        <BaseInput label="CEP" placeholder="" v-model="company.cep" v-maska="MaskService['cep']"  />
                                    </div>
                                </div>
                                <div class="grid grid-cols-2 form-row">
                                    <div>
                                        <BaseSelect :is-invalid="v$.state.$error" @blur="v$.state.$touch" label="Estado" :options="stateOptions" v-model.number="company.state" @change="loadCities(company.state)" :required="true" />
                                        <div v-for="error in v$.$errors" :key="error.$uid">
                                            <BaseErrorMessage v-if="error.$property === 'state'" :message="error.$message" />
                                        </div>
                                    </div>
                                    <div>
                                        <BaseSelect :is-invalid="v$.city.$error" @blur="v$.city.$touch" label="Cidade" :options="citiesOptions" :disabled="!company.state" v-model.number="company.city" :required="true" />
                                        <div v-for="error in v$.$errors" :key="error.$uid">
                                            <BaseErrorMessage v-if="error.$property === 'city'" :message="error.$message" />
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-1 form-row">
                                    <div>
                                        <label class="label">Número de participações PDI</label>
                                        <div class="mt-2 flex items-center gap-x-2">
                                            <button
                                                type="button"
                                                @click="decreasePdiParticipationCount"
                                                :disabled="company.pdi_participation_count <= 1"
                                                class="w-8 h-8 rounded-md border border-green-200 text-green-700 font-bold hover:bg-green-50 disabled:opacity-0 disabled:cursor-default"
                                            >
                                                -
                                            </button>
                                            <div class="min-w-[56px] h-8 px-3 rounded-md border border-green-200 bg-green-50 flex items-center justify-center text-lg font-bold text-green-700">
                                                {{ company.pdi_participation_count }}
                                            </div>
                                            <button
                                                type="button"
                                                @click="increasePdiParticipationCount"
                                                class="w-8 h-8 rounded-md border border-green-200 text-green-700 font-bold hover:bg-green-50"
                                            >
                                                +
                                            </button>
                                        </div>
                                        <p class="text-xs text-gray-500 mt-1">
                                            Essa empresa necessita que o colaborador tenha X participação(oes) para pontuar no PDI.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-2 form-row">
                                <div class="px-8 flex items-start">
                                    <div class="flex items-start gap-x-6">
                                        <div class="flex flex-col">
                                            <a class="flex gap-x-4 mt-4 hover:bg-green-100 p-2 rounded-md" target="_blank" :href="company.file_url">
                                                <span class="text-green-500 font-bold">{{ company.file_url ? 'ANEXADO' : 'SEM ARQUIVO' }}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" v-if="company.file_url" class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                                                </svg>
                                            </a>
                                        </div>
                                        <FileUploader class="mt-4" text="Enviar Arquivo" :showProgress="true" @onUpload="onUpload" />
                                        <svg v-if="company.file_url" @click="deleteFile" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-red-600 mt-6 cursor-pointer">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.108 0 00-7.5 0" />
                                        </svg>
                                    </div>
                                    <div class="ml-auto mt-4">
                                        <BaseButton skin="primary" :is-submit="true">{{ isEdit ? 'Atualizar': 'Salvar' }}</BaseButton>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </template>
                    </BaseFormContainer>
                    </div>
                </div>
            </form>
        </div>

        <ModalV2 ref="modalRef" :hide="true" :title="workerModalTitle" size="xl" action-text="Salvar" trigger-text="Adicionar">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
                </svg>
            </template>
            <template v-slot:body>
                <div class="grid gap-6" style="grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);">
                    <div class="space-y-6">
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <BaseInput label="Nome" maxlength="30" v-model="worker.name" required="true" />
                            </div>
                            <div>
                                <BaseSelect :options="roleOptions" defaultValue="worker" label="Cargo" v-model="worker.role" />
                            </div>
                            <div>
                                <BaseInput label="Email" maxlength="60" v-model="worker.email" />
                            </div>
                            <div>
                                <BaseInput label="Documento" maxlength="100" v-model="worker.document" v-maska="MaskService['document']" />
                            </div>
                        </div>

                        <div class="grid grid-cols-2 gap-4">
                            <div class="rounded border border-gray-200 px-4 py-3">
                                <BaseCheckbox label="Enxerga todos os PDIs" v-model="worker.see_globalpdi" />
                            </div>
                            <div class="rounded border border-gray-200 px-4 py-3">
                                <BaseCheckbox label="Acessa portal do cliente" v-model="worker.portal_access" />
                            </div>
                        </div>

                        <div v-if="isEditWorker && worker.portal_user" class="rounded border border-green-100 bg-green-50 p-4">
                            <div class="flex items-center gap-2 text-sm font-semibold" :class="worker.portal_user.status ? 'text-green-700' : 'text-gray-600'">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z" />
                                </svg>
                                <span>{{ worker.portal_user.status ? 'Acesso ao portal ativo' : 'Acesso ao portal revogado' }}</span>
                            </div>
                            <div class="mt-3 flex gap-x-3">
                                <BaseButton skin="danger-outline-small" :disabled="loadingPortalUserToggle" @click="toggleWorkerPortalAccess">
                                    {{ worker.portal_user.status ? 'Revogar Acesso' : 'Reativar Acesso' }}
                                </BaseButton>
                                <BaseButton skin="primary-outline-small" :disabled="loadingPortalUserResetPassword" @click="resetWorkerPortalPassword">Resetar Senha</BaseButton>
                            </div>
                        </div>

                        <div class="rounded border border-blue-100 bg-blue-50 p-4">
                            <div class="flex items-center gap-2 text-sm font-semibold text-blue-700">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 13.5 10.5 6.75l4.5 4.5L20.25 6" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6h3v3" />
                                </svg>
                                <span>Simulador de bonificação</span>
                            </div>

                            <div class="mt-4 grid gap-4" style="grid-template-columns: minmax(0, 0.8fr) minmax(0, 0.8fr) minmax(0, 1fr);">
                                <div>
                                    <label class="label">Competência</label>
                                    <Datepicker
                                        :clearable="false"
                                        locale="pt-BR"
                                        monthPicker
                                        v-model="workerBonusSimulationCompetenceDate"
                                        @update:modelValue="onChangeWorkerBonusSimulationCompetence"
                                        autoApply
                                    />
                                </div>
                                <div>
                                    <BaseInput label="Pontos" placeholder="Digite a pontuação" v-model="workerBonusSimulationScore" />
                                </div>
                                <div>
                                    <label class="label">Valor previsto</label>
                                    <div class="h-[46px] px-1 flex items-center text-2xl font-bold text-blue-700">
                                        {{ workerBonusSimulationAmountLabel }}
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-sm text-blue-700">
                                {{ workerBonusSimulationDescription }}
                            </div>
                        </div>
                    </div>

                    <div class="border-l border-gray-200 pl-6">
                        <div>
                            <h4 class="text-base font-bold text-gray-700">Bonificação do PDI por Competência</h4>
                        </div>

                        <div v-if="worker.id" class="mt-4">
                            <div class="min-w-[220px] max-w-[260px]">
                                <label class="label">Data de Competência</label>
                                <Datepicker
                                    :clearable="false"
                                    locale="pt-BR"
                                    monthPicker
                                    v-model="workerBonusCompetenceDate"
                                    @update:modelValue="onChangeWorkerBonusCompetence"
                                    autoApply
                                />
                            </div>
                        </div>

                        <div v-if="!worker.id" class="mt-4 rounded border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-700">
                            Salve o colaborador primeiro para cadastrar as faixas de bonificação do PDI.
                        </div>

                        <div v-else class="mt-5">
                            <div v-if="loadingWorkerBonusRules" class="rounded border border-gray-200 bg-gray-50 px-4 py-5">
                                <div class="flex items-center gap-3 text-sm font-semibold text-gray-600">
                                    <svg class="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    <span>Carregando bonificação da competência selecionada...</span>
                                </div>
                            </div>

                            <div v-else class="space-y-4">
                                <div
                                    v-for="(rule, index) in workerBonusRules"
                                    :key="rule.local_id"
                                    class="rounded border border-gray-200 p-4"
                                >
                                    <div class="grid gap-3 items-end" style="grid-template-columns: minmax(0, 0.8fr) minmax(0, 0.8fr) minmax(0, 1fr) auto;">
                                        <div>
                                            <BaseInput label="Pontuação inicial" placeholder="0" v-model="rule.score_start" />
                                        </div>
                                        <div>
                                            <BaseInput label="Pontuação final" placeholder="4" v-model="rule.score_end" />
                                        </div>
                                        <div>
                                            <BaseInputMoney label="Bonificação" v-model="rule.bonus_amount" />
                                        </div>
                                        <div v-if="index > 0" class="pb-1">
                                            <BaseButton skin="danger-outline-small" @click="removeWorkerBonusRule(index)">Remover</BaseButton>
                                        </div>
                                    </div>
                                    <div v-if="getWorkerBonusRuleError(index)" class="mt-2 text-sm font-semibold text-red-500">
                                        {{ getWorkerBonusRuleError(index) }}
                                    </div>
                                </div>

                                <div class="flex flex-wrap items-center gap-x-8 gap-y-3">
                                    <BaseCheckbox
                                        :label="`Aplicar para todos os meses do ano ${workerBonusCompetenceDate?.year || ''}`"
                                        v-model="applyWorkerBonusToAllMonths"
                                    />
                                    <BaseCheckbox
                                        label="Aplicar para todos os colaboradores"
                                        v-model="applyWorkerBonusToAllWorkers"
                                    />
                                </div>

                                <div>
                                    <div class="flex justify-end gap-3">
                                        <BaseButton skin="primary-small" :disabled="savingWorkerBonusRules || loadingWorkerBonusRules" @click="saveWorkerBonusRules">
                                            <svg v-if="savingWorkerBonusRules" class="animate-spin ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Salvar Bonificação
                                        </BaseButton>
                                        <div class="flex justify-end">
                                            <BaseButton skin="primary-outline-small" @click="addWorkerBonusRule">Adicionar Faixa</BaseButton>
                                        </div>
                                    </div>

                                    <div
                                        v-if="savingWorkerBonusRules && applyWorkerBonusToAllWorkers"
                                        class="mt-3 text-right text-sm text-gray-500"
                                    >
                                        Isso pode levar um tempinho, aguarde{{ workerBonusSaveLoadingDots }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <BaseButton skin="primary-outline" @click="setModalStatus('close')">Fechar</BaseButton>
                <BaseButton skin="primary" :disabled="loadingSubmitWorker" @click="submitWorker">
                    <svg v-if="loadingSubmitWorker" class="animate-spin ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ isEditWorker ? 'Atualizar' : 'Salvar' }}
                </BaseButton>
            </template>
        </ModalV2>

        <ModalV2 ref="groupModalRef" :hide="true" :title="isEditWorkerGroup ? 'Editar Grupo de Colaboradores' : 'Novo Grupo de Colaboradores'" action-text="Salvar" trigger-text="Adicionar">
            <template v-slot:body>
                <div class="flex flex-col gap-y-4">
                    <BaseInput label="Nome do grupo" maxlength="40" v-model="workerGroupForm.name" required="true" />

                    <div>
                        <span class="text-sm font-semibold text-gray-600">Cor do grupo</span>
                        <div class="grid grid-cols-10 gap-2 mt-2">
                            <button
                                v-for="color in availableGroupColors"
                                :key="color.value"
                                type="button"
                                :title="color.name"
                                @click="setWorkerGroupColor(color.value)"
                                class="w-7 h-7 rounded-full border-2"
                                :class="{ 'border-black': workerGroupForm.color === color.value, 'border-transparent': workerGroupForm.color !== color.value }"
                                :style="{ backgroundColor: color.value }"
                            ></button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <BaseButton skin="primary-outline" @click="setGroupModalStatus('close')">Fechar</BaseButton>
                <BaseButton skin="primary" :disabled="loadingCreateWorkerGroup" @click="saveWorkerGroup">
                    <svg v-if="loadingCreateWorkerGroup" class="animate-spin ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ isEditWorkerGroup ? 'Atualizar' : 'Salvar' }}
                </BaseButton>
            </template>
        </ModalV2>

        <div id="company-colaboradores" class="grid grid-cols-1 mt-4" v-if="!loading && company.id">
            <div class="company-workers-card">
                <BaseFormContainer title="Colaboradores">
                    <template v-slot:form>
                        <div class="grid grid-cols-1 xl:grid-cols-4 gap-4 xl:gap-x-8 items-end">
                            <div class="flex flex-wrap gap-4">
                                <BaseButton skin="primary" @click="addNewWorker()">
                                    <template v-slot:icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                        </svg>
                                    </template>
                                    Adicionar
                                </BaseButton>

                                <BaseButton @click="loadWorkers(showInactiveWorkers)" :disabled="loadingWorkers" skin="primary-outline">Atualizar</BaseButton>
                            </div>

                            <div>
                                <BaseInput placeholder="Pesquisar por nome" v-model="searchWorker" />
                            </div>
                            <div class="flex flex-wrap items-center justify-start xl:justify-end gap-6 xl:col-span-2">
                                <BaseCheckbox label="Mostrar Inativos" v-model="showInactiveWorkers" @change="toggleShowInactiveWorkers(showInactiveWorkers)" />
                                <div class="flex items-center gap-2 text-sm font-semibold text-gray-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-5 h-5 text-green-600">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z" />
                                    </svg>
                                    <span>Tem acesso ao portal</span>
                                </div>
                            </div>
                        </div>
                        <Alert class="mt-4" text="Ainda não existem colaboradores cadastrados nessa empresa" :show="!workers.length && !loading" />
                        
                        <!-- loading workers -->
                        <div class="flex flex-col mt-6" v-if="loadingWorkers">
                            <div class="flex gap-x-2 justify-center items-center">
                                <svg class="animate-spin ml-1 mr-3 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span class="text-gray-500 font-semibold text-lg">Aguarde... Listando colaboradores</span>
                            </div>

                            <div class="mx-auto w-full max-w-sm rounded-md p-4">
                                <div class="flex animate-pulse space-x-4">
                                    <div class="flex-1 space-y-6 py-1">
                                    <div class="h-2 rounded bg-gray-200"></div>
                                    <div class="space-y-3">
                                        <div class="grid grid-cols-3 gap-4">
                                        <div class="col-span-2 h-2 rounded bg-gray-200"></div>
                                        <div class="col-span-1 h-2 rounded bg-gray-200"></div>
                                        </div>
                                        <div class="h-2 rounded bg-gray-200"></div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </BaseFormContainer>
            </div>

            <!-- {{ selectedWorkers }} -->
            <div class="table-container company-workers-table" v-show="workers.length && !loadingEntireScreen">
                <div class="flex gap-x-4">
                    <BaseButton @click="cancelMarkTeam()" v-if="showWorkersCheckBox" skin="danger-outline-small">Cancelar Seleção</BaseButton>
                    <BaseButton @click="linkBoss()" :disabled="loadingConfirmLinkBoss" v-if="showWorkersCheckBox && hasAnyWorkerSelected()" skin="primary-outline-small">Confirmar Seleção</BaseButton>
                    <svg v-if="loadingConfirmLinkBoss" class="animate-spin h-6 w-6 mt-1 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>

                <!-- table workers -->
                <table v-if="!loadingWorkers" class="min-w-full mb-12">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nome</th>
                            <th>Cargo</th>
                            <th>Email</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="{ 'bg-blue-50': worker.id == selectedBossId, 'opacity-25': !worker.is_active }" class="table-row-compact" v-for="worker in filteredWorkers" :key="worker.id">
                            <td>
                                <BaseCheckbox v-if="showWorkersCheckBox && worker.role !== 'director' && !worker.boss.length && worker.id !== selectedBossId" v-model="selectedWorkers[worker.id]"></BaseCheckbox>
                            </td>
                            <td>
                                <div class="flex gap-x-2">
                                    <div :class="{ 
                                        'text-green-700': worker.role === 'worker',
                                        'text-blue-400': worker.role === 'manager',
                                        'text-yellow-500': worker.role === 'director',
                                        'text-red-400': !worker.is_active,
                                        'pl-12 text-sm border-l border-green-500': worker.boss.length,
                                        'pl-20 text-sm border-l border-green-500': bossHasBoss(worker.id),
                                        'text-base animate-bounce': worker.id == selectedBossId }" class="leading-5 font-semibold uppercase">
                                        {{ worker.name }}
                                    </div>
                                    <svg v-if="worker.boss.length" @click="removeFromBoss(worker)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-red-400 cursor-pointer">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z" />
                                    </svg>
                                    <svg v-if="loadingRemoveFromBoss[worker.id]" class="animate-spin h-6 w-6 text-gray-40" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    
                                    <BaseButton @click="activateMarkTeam(worker.id)" class="-mt-0.5" v-if="worker.role !== 'worker' && selectedBossId == null" skin="primary-outline-xs">
                                        <template v-slot:icon>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                            </svg>
                                        </template>
                                        Liderados
                                    </BaseButton>
                                </div>
                            </td>
                            <td>
                                <Tag size="sm" type="success" text="colaborador" v-show="worker.role === 'worker'"></Tag>
                                <Tag size="sm" type="info" text="gerente" v-show="worker.role === 'manager'"></Tag>
                                <Tag size="sm" type="warning" text="diretor" v-show="worker.role === 'director'"></Tag>
                            </td>
                            <td>
                                <div class="flex items-center gap-x-2">
                                    <span class="text-sm leading-5 text-green-700 font-semibold">{{ worker.email }}</span>
                                    <svg
                                        v-if="worker.portal_user"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.8"
                                        stroke="currentColor"
                                        class="w-6 h-6"
                                        :class="worker.portal_user.status ? 'text-green-600' : 'text-gray-400'"
                                        :title="worker.portal_user.status ? 'Acessa portal do cliente' : 'Acesso ao portal revogado'"
                                    >
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z" />
                                    </svg>
                                </div>
                            </td>
                            <td>
                                <div class="flex gap-x-4">
                                    <svg v-if="worker.is_active" @click="setModalItem(worker)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cursor-pointer w-6 text-gray-500">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>

                                    <!-- Toggle is active controls -->
                                    <div>
                                        <svg v-if="loadingToggleWorkerStatus[worker.id]" class="animate-spin h-6 w-6 text-gray-40" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        <!-- Back Active -->
                                        <svg v-if="!loadingToggleWorkerStatus[worker.id] && !worker.is_active" @click="toggleWorkerStatus(worker.id)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cursor-pointer w-6 text-gray-500">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                                        </svg>
                                        <!-- Inactivate -->
                                        <svg v-if="!loadingToggleWorkerStatus[worker.id] && worker.is_active" @click="toggleWorkerStatus(worker.id)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cursor-pointer w-6 text-gray-500">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div id="company-setores" class="grid grid-cols-1 mt-4" v-if="!loading && company.id">
            <BaseFormContainer title="Setores e Agrupamento">
                <template v-slot:form>
                    <div class="flex gap-x-4">
                        <BaseButton skin="primary" @click="addNewWorkerGroup()">
                            <template v-slot:icon>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                </svg>
                            </template>
                            Adicionar Grupo
                        </BaseButton>

                        <BaseButton @click="loadWorkerGroups()" :disabled="loadingWorkerGroups" skin="primary-outline">Atualizar</BaseButton>
                    </div>

                    <div class="mt-6">
                        <div class="flex flex-wrap items-center gap-4">
                            <h3 class="text-sm font-bold text-gray-600 uppercase">Disponiveis para agrupar</h3>
                            <div class="flex flex-wrap items-center gap-3">
                                <div class="flex items-center gap-2">
                                    <span class="w-3 h-3 rounded-sm bg-green-500"></span>
                                    <span class="text-xs text-gray-600 font-semibold uppercase">Colaborador</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <span class="w-3 h-3 rounded-sm bg-blue-500"></span>
                                    <span class="text-xs text-gray-600 font-semibold uppercase">Gerente</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <span class="w-3 h-3 rounded-sm bg-yellow-500"></span>
                                    <span class="text-xs text-gray-600 font-semibold uppercase">Diretor</span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="mt-2 min-h-16 rounded border-2 border-dashed border-gray-300 p-3 bg-gray-50"
                            @dragover.prevent
                            @dragenter.prevent="setDragPreviewTarget(null)"
                            @drop.prevent="onDropWorkerWithoutGroup"
                        >
                            <div class="text-xs text-gray-500 mb-2">Gerentes e diretores permanecem disponiveis para entrar em mais de um grupo.</div>
                            <div v-if="workersAvailableForGrouping.length" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
                                <div
                                    v-for="worker in workersAvailableForGrouping"
                                    :key="worker.id"
                                    class="flex items-center bg-white border border-gray-200 rounded overflow-hidden cursor-move transition-opacity"
                                    :class="{ 'opacity-60': isPreviewPlacement(worker.id, null) }"
                                    draggable="true"
                                    @dragstart="onWorkerDragStart(worker.id)"
                                    @dragend="onWorkerDragEnd"
                                >
                                    <div class="w-2 h-10" :class="getWorkerRoleStripClass(worker.role)"></div>
                                    <div class="px-3 py-2 flex-1">
                                        <span class="text-sm font-semibold text-gray-700 uppercase">{{ worker.name }}</span>
                                        <div class="text-gray-500 uppercase mt-1" style="font-size: 10px; line-height: 1;">{{ getWorkerAvailabilityLabel(worker) }}</div>
                                    </div>
                                    <svg v-if="loadingAssignWorkerGroup[worker.id]" class="animate-spin mr-3 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>
                            </div>
                            <div v-else class="text-sm text-gray-500">Nao ha colaboradores disponiveis para agrupamento no momento.</div>
                        </div>
                    </div>

                    <div class="mt-4 flex items-start gap-4">
                        <div class="flex-1 min-w-0">
                            <div v-if="loadingWorkerGroups" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <div v-for="item in 4" :key="`group-skeleton-${item}`" class="rounded border-2 border-gray-200 bg-white overflow-hidden animate-pulse">
                                    <div class="h-10 bg-gray-200"></div>
                                    <div class="p-3 min-h-24 bg-gray-50">
                                        <div class="h-3 w-36 bg-gray-200 rounded mb-3"></div>
                                        <div class="space-y-2">
                                            <div class="h-10 bg-white border border-gray-200 rounded"></div>
                                            <div class="h-10 bg-white border border-gray-200 rounded"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Alert text="Nenhum grupo cadastrado para esta empresa" :show="!workerGroups.length && !loadingWorkerGroups" />

                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" v-if="workerGroups.length && !loadingWorkerGroups">
                                <div
                                    v-for="group in workerGroups"
                                    :key="group.id"
                                    class="rounded border-2 bg-white overflow-hidden"
                                    :class="{ 'opacity-60': loadingDeleteWorkerGroup[group.id] }"
                                    :style="{ borderColor: group.color }"
                                >
                                    <div class="relative flex items-center justify-between px-4 pr-6 py-2 font-bold text-sm uppercase tracking-wide" :style="{ backgroundColor: group.color, color: '#ffffff' }">
                                        <div class="flex items-center gap-2">
                                            <span>{{ group.name }}</span>
                                            <svg v-if="loadingDeleteWorkerGroup[group.id]" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                        </div>
                                        <button
                                            type="button"
                                            @click="toggleGroupActions(group.id)"
                                            class="ml-3 h-7 w-7 flex items-center justify-center text-white text-2xl leading-none cursor-pointer"
                                            :disabled="loadingDeleteWorkerGroup[group.id]"
                                        >
                                            <span class="-mt-1">...</span>
                                        </button>

                                        <div v-if="openGroupActionsId === group.id" class="absolute right-3 top-10 z-10 w-32 bg-white rounded shadow border border-gray-200 py-1">
                                            <button type="button" @click="openEditWorkerGroup(group)" class="w-full text-left px-3 py-2 text-xs text-gray-700 hover:bg-gray-100">Editar</button>
                                            <button type="button" @click="deleteWorkerGroup(group)" class="w-full text-left px-3 py-2 text-xs text-red-500 hover:bg-gray-100">Excluir</button>
                                        </div>
                                    </div>
                                    <div
                                        class="p-3 min-h-24 bg-gray-50"
                                        @dragover.prevent="onGroupContainerDragOver($event, group.id)"
                                        @dragenter.prevent="setDragPreviewTarget(group.id)"
                                        @drop.prevent="onDropWorkerOnGroup(group.id)"
                                    >
                                        <div class="text-xs text-gray-500 mb-2">Arraste colaboradores para este grupo</div>

                                        <div v-if="getWorkersByGroup(group.id).length" class="space-y-2">
                                            <template v-for="worker in getWorkersByGroup(group.id)" :key="worker.id">
                                                <div
                                                    class="flex items-center bg-white border border-gray-200 rounded overflow-hidden cursor-move transition-all duration-150"
                                                    :class="{ 'opacity-60': isPreviewPlacement(worker.id, group.id) }"
                                                    draggable="true"
                                                    @dragstart="onWorkerDragStart(worker.id, group.id)"
                                                    @dragend="onWorkerDragEnd"
                                                    @drop.stop.prevent="onDropWorkerOnGroup(group.id)"
                                                >
                                                    <div class="w-2 h-10" :class="getWorkerRoleStripClass(worker.role)"></div>
                                                    <div class="px-3 py-2 flex-1">
                                                        <span class="text-sm font-semibold text-gray-700 uppercase">{{ worker.name }}</span>
                                                    </div>
                                                    <svg v-if="loadingAssignWorkerGroup[worker.id]" class="animate-spin mr-3 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                    </svg>
                                                </div>
                                            </template>
                                        </div>
                                        <div v-else class="text-sm text-gray-500">Sem colaboradores neste grupo.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="sticky top-24 self-start transition-all duration-300 ease-in-out" :class="isUngroupedDrawerOpen ? 'w-80' : 'w-10'">
                            <div
                                class="flex"
                                @dragover.prevent
                                @dragenter.prevent="setDragPreviewTarget(null)"
                                @drop.prevent="onDropWorkerWithoutGroup"
                            >
                                <button
                                    type="button"
                                    @click="toggleUngroupedDrawer"
                                    class="h-12 w-10 rounded-l bg-green-500 text-white font-bold text-lg cursor-pointer shadow"
                                    :title="isUngroupedDrawerOpen ? 'Fechar disponiveis para agrupar' : 'Abrir disponiveis para agrupar'"
                                >
                                    <svg v-if="isUngroupedDrawerOpen" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>

                                <div v-if="isUngroupedDrawerOpen" class="flex-1 border border-green-200 rounded-r bg-white shadow-sm">
                                    <div class="px-3 py-3 border-b border-gray-100">
                                        <h3 class="text-xs font-bold text-gray-700 uppercase">Disponiveis para agrupar</h3>
                                        <div class="flex flex-wrap items-center gap-2 mt-2">
                                            <div class="flex items-center gap-1">
                                                <span class="w-2.5 h-2.5 rounded-sm bg-green-500"></span>
                                                <span class="text-[10px] text-gray-600 font-semibold uppercase">Colaborador</span>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <span class="w-2.5 h-2.5 rounded-sm bg-blue-500"></span>
                                                <span class="text-[10px] text-gray-600 font-semibold uppercase">Gerente</span>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <span class="w-2.5 h-2.5 rounded-sm bg-yellow-500"></span>
                                                <span class="text-[10px] text-gray-600 font-semibold uppercase">Diretor</span>
                                            </div>
                                        </div>
                                        <p class="text-[10px] text-gray-500 mt-2">Colaboradores sem grupo aparecem aqui. Gerentes e diretores continuam disponiveis mesmo apos entrar em grupos.</p>
                                    </div>

                                    <div class="p-2 max-h-[70vh] overflow-y-auto">
                                        <div v-if="workersAvailableForGrouping.length" class="space-y-2">
                                            <div
                                                v-for="worker in workersAvailableForGrouping"
                                                :key="worker.id"
                                                class="flex items-center bg-white border border-gray-200 rounded overflow-hidden cursor-move transition-opacity"
                                                :class="{ 'opacity-60': isPreviewPlacement(worker.id, null) }"
                                                draggable="true"
                                                @dragstart="onWorkerDragStart(worker.id)"
                                                @dragend="onWorkerDragEnd"
                                            >
                                                <div class="w-2 h-10" :class="getWorkerRoleStripClass(worker.role)"></div>
                                                <div class="px-3 py-2 flex-1 min-w-0">
                                                    <span class="text-xs font-semibold text-gray-700 uppercase block truncate">{{ worker.name }}</span>
                                                    <span class="text-gray-500 uppercase block mt-1 truncate" style="font-size: 10px; line-height: 1;">{{ getWorkerAvailabilityLabel(worker) }}</span>
                                                </div>
                                                <svg v-if="loadingAssignWorkerGroup[worker.id]" class="animate-spin mr-3 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <div v-else class="text-xs text-gray-500 p-2">Nao ha colaboradores disponiveis para agrupamento no momento.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BaseFormContainer>
        </div>

        <div id="company-usuarios" class="grid grid-cols-1 mt-4" v-if="!loading && company.id">
            <BaseFormContainer title="Usuários com acesso ao portal do cliente">
                <template v-slot:form>
                    <div class="text-xs text-gray-500 mb-4">Sessão mantida para gerenciar usuários legados. Novos acessos devem ser criados pelo cadastro de colaboradores.</div>

                    <Alert text="Ainda não existem usuários cadastrados para esta empresa" :show="!users.length && !loading" />

                    <div class="mt-4" v-if="users.length && !loading">
                        <table class="min-w-full">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Foto</th>
                                    <th>Nome</th>
                                    <th>Email</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-row" v-for="(user, index) in users" :key="user.id">
                                    <td class="">
                                        <div class="flex items-center">
                                            <div>
                                                <div class="text-sm leading-5 text-gray-800">#{{ index + 1 }}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <BaseButton skin="primary-outline" :to="{ name: 'user', params: { company_id: user.company, user_id: user.id }}">Gerenciar</BaseButton>
                                    </td>
                                    <td>
                                        <ThumbRounded class="mr-12" :path="user.photo_url" />
                                    </td>
                                    <td>
                                        <span class="text-sm leading-5 text-green-700">{{ user.name }}</span>
                                    </td>
                                    <td>
                                        <span class="text-sm leading-5 text-green-700">{{ user.email }}</span>
                                    </td>
                                    <td>
                                        <Tag v-if="user.status" type="success" text="ativo" />
                                        <Tag v-if="!user.status" type="danger" text="inativo" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </BaseFormContainer>
        </div>

    </div>
</template>

<script>

import { ref, computed, watch, onBeforeUnmount } from 'vue';
import BackButton from '../components/BackButton.vue';
import Swal from 'sweetalert';
import { useRoute, useRouter } from 'vue-router';
import MaskService from '../services/MaskService';
import ThumbRounded from '../components/ThumbRounded.vue';
import Tag from '../components/Tag.vue';
import Alert from '../components/Alert.vue';
import TailwindColorService from '../services/TailwindColorService';
import FileUploader from '@/components/FileUploader';
import { useVuelidate } from '@vuelidate/core'
import { CompanyService, GeoInfoService, UserService, WorkerService, WorkerGroupService } from '../services/Entity';
import { 
    requiredMessage,
    minLengthMessage,
} from '../services/VuelidateMessageService';
import ModalV2 from '../components/ModalV2';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    components: {
        FileUploader,
        BackButton,
        ThumbRounded,
        Tag,
        Alert,
        ModalV2
    },
    setup() {
        const pageHeader = ref('Cliente');
        const loading = ref(false);
        const isEdit = ref(true);
        const stateOptions = ref([]);
        const citiesOptions = ref([]);
        const users = ref([]);
        const company = ref({
            name: '',
            pdi_participation_count: 1
        });
        const route = useRoute();
        const router = useRouter();
        const rules = computed(() => ({
            name: { required: requiredMessage, minLength: minLengthMessage(2) },
            state: { required: requiredMessage },
            city: { required: requiredMessage }
        }));
        const workers = ref([]);
        const worker = ref({});
        const roleOptions = ref([
            {
                title: 'Colaborador',
                value: 'worker'
            },
            {
                title: 'Coordenador/Supervisor/Gerente',
                value: 'manager'
            },
            {
                title: 'Diretor/CEO',
                value: 'director'
            }
        ]);
        const modalRef = ref();
        const isEditWorker = ref(false);
        const selectedWorkers = ref({});
        const showWorkersCheckBox = ref(false);
        const selectedBossId = ref(null);
        const showInactiveWorkers = ref(false);
        const loadingSubmitWorker = ref(false);
        const loadingWorkers = ref(false);
        const loadingToggleWorkerStatus = ref({});
        const loadingPortalUserToggle = ref(false);
        const loadingPortalUserResetPassword = ref(false);
        const loadingRemoveFromBoss = ref({});
        const loadingConfirmLinkBoss = ref(false);
        const searchWorker = ref('');
        const workerGroups = ref([]);
        const loadingWorkerGroups = ref(false);
        const loadingCreateWorkerGroup = ref(false);
        const loadingAssignWorkerGroup = ref({});
        const loadingDeleteWorkerGroup = ref({});
        const isUngroupedDrawerOpen = ref(false);
        const groupModalRef = ref();
        const isEditWorkerGroup = ref(false);
        const editingWorkerGroupId = ref(null);
        const openGroupActionsId = ref(null);
        const workerGroupForm = ref({
            name: '',
            color: ''
        });
        const workerBonusRuleId = ref(0);
        const workerBonusCompetenceDate = ref(getCurrentCompetenceDate());
        const workerBonusRules = ref([createEmptyWorkerBonusRule()]);
        const workerBonusRuleErrors = ref({});
        const loadingWorkerBonusRules = ref(false);
        const savingWorkerBonusRules = ref(false);
        const applyWorkerBonusToAllMonths = ref(false);
        const applyWorkerBonusToAllWorkers = ref(false);
        const workerBonusSaveLoadingDots = ref('.');
        let workerBonusSaveLoadingDotsInterval = null;
        const workerBonusSimulationCompetenceDate = ref(getCurrentCompetenceDate());
        const workerBonusSimulationScore = ref('');
        const workerBonusSimulationRules = ref([]);
        const loadingWorkerBonusSimulationRules = ref(false);
        const draggedWorkerId = ref(null);
        const draggedWorkerSourceGroupId = ref(null);
        const previewTargetGroupId = ref(undefined);
        const availableGroupColors = TailwindColorService.getVibrantColors();
        const workerModalTitle = computed(() => {
            const name = (worker.value?.name || '').trim();
            return name ? `Cadastro Colaborador - ${name}` : 'Cadastro Colaborador - Novo colaborador';
        });
        const workerBonusSimulationAmount = computed(() => {
            const score = normalizeWorkerBonusNumber(workerBonusSimulationScore.value);

            if (score === null) {
                return null;
            }

            const shouldUseEditingRules = (
                workerBonusSimulationCompetenceDate.value?.month === workerBonusCompetenceDate.value?.month &&
                workerBonusSimulationCompetenceDate.value?.year === workerBonusCompetenceDate.value?.year
            );
            const sourceRules = shouldUseEditingRules ? workerBonusRules.value : workerBonusSimulationRules.value;
            const comparableRules = sourceRules
                .map(rule => ({
                    score_start: normalizeWorkerBonusNumber(rule.score_start),
                    score_end: normalizeWorkerBonusNumber(rule.score_end),
                    bonus_amount: normalizeWorkerBonusNumber(rule.bonus_amount)
                }))
                .filter(rule =>
                    rule.score_start !== null &&
                    rule.score_end !== null &&
                    rule.bonus_amount !== null &&
                    rule.score_end > rule.score_start
                )
                .sort((ruleA, ruleB) => ruleA.score_start - ruleB.score_start);

            const matchedRule = comparableRules.find(rule => score >= rule.score_start && score <= rule.score_end);

            return matchedRule ? matchedRule.bonus_amount : 0;
        });
        const workerBonusSimulationAmountLabel = computed(() => {
            if (workerBonusSimulationAmount.value === null) {
                return 'R$ 0,00';
            }

            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(workerBonusSimulationAmount.value);
        });
        const workerBonusSimulationDescription = computed(() => {
            const score = normalizeWorkerBonusNumber(workerBonusSimulationScore.value);
            const shouldUseEditingRules = (
                workerBonusSimulationCompetenceDate.value?.month === workerBonusCompetenceDate.value?.month &&
                workerBonusSimulationCompetenceDate.value?.year === workerBonusCompetenceDate.value?.year
            );

            if (score === null) {
                return 'Digite a pontuação para simular o valor da bonificação com base nas faixas atuais.';
            }

            if (loadingWorkerBonusSimulationRules.value && !shouldUseEditingRules) {
                return 'Carregando regras salvas da competência selecionada para simulação.';
            }

            if (workerBonusSimulationAmount.value === 0) {
                return 'Nenhuma faixa atual atende essa pontuação.';
            }

            if (shouldUseEditingRules) {
                return 'Valor calculado com base nas faixas atualmente montadas no modal.';
            }

            return 'Valor calculado com base nas regras salvas da competência selecionada no simulador.';
        });
        const filteredWorkers = computed(() => {
            const query = searchWorker.value.trim().toLowerCase();

            // Se não tiver busca, retorna todos os workers
            if (!query) {
                return workers.value;
            }

            // Filtrar os que batem com o nome buscado
            const matched = workers.value.filter(w =>
                w.name.toLowerCase().includes(query)
            );

            // Coletar todos os IDs dos matched
            const matchedIds = new Set(matched.map(w => w.id));

            // Incluir também os líderes (bosses) de cada matched
            matched.forEach(w => {
                if (Array.isArray(w.boss)) {
                    w.boss.forEach(bossId => matchedIds.add(bossId));
                }
            });

            // Retorna apenas os workers cujos IDs estão no matchedIds
            return workers.value.filter(w => matchedIds.has(w.id));
        });
        const workerGroupMembershipMap = computed(() => {
            const map = {};

            workerGroups.value.forEach(group => {
                (group.worker_ids || []).forEach(workerId => {
                    if (!map[workerId]) {
                        map[workerId] = [];
                    }

                    map[workerId].push(group.id);
                });
            });

            return map;
        });

        function isMultiGroupRole(role) {
            return role === 'manager' || role === 'director';
        }

        function getCurrentCompetenceDate() {
            const now = new Date();

            return {
                month: now.getMonth(),
                year: now.getFullYear()
            };
        }

        function createEmptyWorkerBonusRule() {
            workerBonusRuleId.value += 1;

            return {
                local_id: workerBonusRuleId.value,
                score_start: '',
                score_end: '',
                bonus_amount: ''
            };
        }

        function normalizeWorkerBonusNumber(value) {
            if (value === null || typeof value === 'undefined' || value === '') {
                return null;
            }

            if (typeof value === 'number') {
                return Number.isFinite(value) ? value : null;
            }

            const normalized = String(value)
                .replace(/[^\d,-.]/g, '')
                .replace(/\.(?=.*\.)/g, '')
                .replace(',', '.');
            const parsed = Number(normalized);

            return Number.isFinite(parsed) ? parsed : null;
        }

        function getWorkerBonusRuleMessage(errorCode) {
            if (errorCode === 'missing_fields') {
                return '';
            }

            if (errorCode === 'invalid_range') {
                return 'A pontuação final deve ser maior do que a pontuação inicial.';
            }

            if (errorCode === 'invalid_bonus_amount') {
                return 'A bonificação deve ser maior ou igual a zero.';
            }

            if (errorCode === 'range_conflict') {
                return 'Essa faixa conflita com outra faixa da mesma competência.';
            }

            return 'Verifique os valores informados.';
        }

        function setWorkerBonusRuleErrors(errors = []) {
            const nextErrors = {};

            errors.forEach(({ index, error }) => {
                if (typeof index === 'undefined') {
                    return;
                }

                if (!nextErrors[index]) {
                    nextErrors[index] = [];
                }

                nextErrors[index].push(getWorkerBonusRuleMessage(error));
            });

            workerBonusRuleErrors.value = nextErrors;
        }

        function getWorkerBonusRuleError(index) {
            const errors = workerBonusRuleErrors.value[index] || [];

            return errors[0] || '';
        }

        function normalizeWorkerBonusRulesForValidation() {
            return workerBonusRules.value.map((rule, index) => {
                const scoreStart = normalizeWorkerBonusNumber(rule.score_start);
                const scoreEnd = normalizeWorkerBonusNumber(rule.score_end);
                const bonusAmount = normalizeWorkerBonusNumber(rule.bonus_amount);
                const isBlank = scoreStart === null && scoreEnd === null && bonusAmount === null;

                return {
                    index,
                    local_id: rule.local_id,
                    score_start: scoreStart,
                    score_end: scoreEnd,
                    bonus_amount: bonusAmount,
                    is_blank: isBlank
                };
            });
        }

        function validateWorkerBonusRules() {
            const normalizedRules = normalizeWorkerBonusRulesForValidation();
            const errors = [];
            const filledRules = normalizedRules.filter(rule => !rule.is_blank);

            filledRules.forEach(rule => {
                if (rule.score_start === null || rule.score_end === null || rule.bonus_amount === null) {
                    errors.push({ index: rule.index, error: 'missing_fields' });
                    return;
                }

                if (rule.score_end <= rule.score_start) {
                    errors.push({ index: rule.index, error: 'invalid_range' });
                }

                if (rule.bonus_amount < 0) {
                    errors.push({ index: rule.index, error: 'invalid_bonus_amount' });
                }
            });

            const comparableRules = filledRules
                .filter(rule => !errors.some(error => error.index === rule.index))
                .sort((ruleA, ruleB) => {
                    if (ruleA.score_start !== ruleB.score_start) {
                        return ruleA.score_start - ruleB.score_start;
                    }

                    if (ruleA.score_end !== ruleB.score_end) {
                        return ruleA.score_end - ruleB.score_end;
                    }

                    return ruleA.index - ruleB.index;
                });

            for (let index = 1; index < comparableRules.length; index++) {
                const previousRule = comparableRules[index - 1];
                const currentRule = comparableRules[index];

                if (currentRule.score_start <= previousRule.score_end) {
                    errors.push({ index: previousRule.index, error: 'range_conflict' });
                    errors.push({ index: currentRule.index, error: 'range_conflict' });
                }
            }

            setWorkerBonusRuleErrors(errors);

            return {
                isValid: !errors.length,
                rules: filledRules
                    .filter(rule => !errors.some(error => error.index === rule.index))
                    .map(rule => ({
                        score_start: rule.score_start,
                        score_end: rule.score_end,
                        bonus_amount: rule.bonus_amount
                    }))
            };
        }

        function resetWorkerBonusSection() {
            workerBonusCompetenceDate.value = getCurrentCompetenceDate();
            workerBonusRules.value = [createEmptyWorkerBonusRule()];
            workerBonusRuleErrors.value = {};
            loadingWorkerBonusRules.value = false;
            savingWorkerBonusRules.value = false;
            applyWorkerBonusToAllMonths.value = false;
            applyWorkerBonusToAllWorkers.value = false;
            workerBonusSimulationCompetenceDate.value = getCurrentCompetenceDate();
            workerBonusSimulationScore.value = '';
            workerBonusSimulationRules.value = [];
            loadingWorkerBonusSimulationRules.value = false;
        }

        function applyWorkerBonusRules(rules = []) {
            workerBonusRules.value = rules.length
                ? rules.map(rule => ({
                    local_id: rule.id || createEmptyWorkerBonusRule().local_id,
                    score_start: rule.score_start,
                    score_end: rule.score_end,
                    bonus_amount: rule.bonus_amount
                }))
                : [createEmptyWorkerBonusRule()];

            workerBonusRuleErrors.value = {};
        }

        async function loadWorkerBonusRules() {
            if (!worker.value?.id || !company.value?.id || !workerBonusCompetenceDate.value) {
                applyWorkerBonusRules([]);
                return;
            }

            try {
                loadingWorkerBonusRules.value = true;
                const { data } = await WorkerService.getBonusRules(
                    worker.value.id,
                    company.value.id,
                    workerBonusCompetenceDate.value.month,
                    workerBonusCompetenceDate.value.year
                );

                applyWorkerBonusRules(data || []);
                loadingWorkerBonusRules.value = false;
            } catch (err) {
                loadingWorkerBonusRules.value = false;
                console.log(err);
                Swal({
                    title: 'Erro ao carregar bonificação',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function onChangeWorkerBonusCompetence() {
            await loadWorkerBonusRules();
        }

        async function loadWorkerBonusSimulationRules() {
            const isSameCompetence = (
                workerBonusSimulationCompetenceDate.value?.month === workerBonusCompetenceDate.value?.month &&
                workerBonusSimulationCompetenceDate.value?.year === workerBonusCompetenceDate.value?.year
            );

            if (isSameCompetence || !worker.value?.id || !company.value?.id || !workerBonusSimulationCompetenceDate.value) {
                workerBonusSimulationRules.value = [];
                return;
            }

            try {
                loadingWorkerBonusSimulationRules.value = true;
                const { data } = await WorkerService.getBonusRules(
                    worker.value.id,
                    company.value.id,
                    workerBonusSimulationCompetenceDate.value.month,
                    workerBonusSimulationCompetenceDate.value.year
                );

                workerBonusSimulationRules.value = data || [];
                loadingWorkerBonusSimulationRules.value = false;
            } catch (err) {
                loadingWorkerBonusSimulationRules.value = false;
                workerBonusSimulationRules.value = [];
                console.log(err);
                Swal({
                    title: 'Erro ao carregar regras do simulador',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function onChangeWorkerBonusSimulationCompetence() {
            await loadWorkerBonusSimulationRules();
        }

        function addWorkerBonusRule() {
            workerBonusRules.value.push(createEmptyWorkerBonusRule());
        }

        function removeWorkerBonusRule(index) {
            if (workerBonusRules.value.length === 1) {
                workerBonusRules.value = [createEmptyWorkerBonusRule()];
                workerBonusRuleErrors.value = {};
                return;
            }

            workerBonusRules.value.splice(index, 1);
            validateWorkerBonusRules();
        }

        async function saveWorkerBonusRules() {
            if (!worker.value?.id) {
                return;
            }

            const { isValid, rules } = validateWorkerBonusRules();

            if (!isValid) {
                toast('Corrija os conflitos das faixas antes de salvar.', {
                    type: 'error',
                    autoClose: 3000
                });
                return;
            }

            try {
                savingWorkerBonusRules.value = true;
                const { data } = await WorkerService.saveBonusRules(worker.value.id, {
                    company: company.value.id,
                    competence_month: workerBonusCompetenceDate.value.month,
                    competence_year: workerBonusCompetenceDate.value.year,
                    apply_to_all_months: applyWorkerBonusToAllMonths.value,
                    apply_to_all_workers: applyWorkerBonusToAllWorkers.value,
                    rules
                });

                applyWorkerBonusRules(data || []);
                savingWorkerBonusRules.value = false;
                const saveScope = [];

                if (applyWorkerBonusToAllMonths.value) {
                    saveScope.push(`todos os meses de ${workerBonusCompetenceDate.value.year}`);
                }

                if (applyWorkerBonusToAllWorkers.value) {
                    saveScope.push('todos os colaboradores');
                }

                toast(saveScope.length
                    ? `Bonificação cadastrada com sucesso para ${saveScope.join(' e ')}.`
                    : 'Bonificação cadastrada com sucesso.', {
                    type: 'success',
                    autoClose: 2500
                });
            } catch (err) {
                savingWorkerBonusRules.value = false;

                if (err?.data?.error === 'invalid_bonus_rules' && Array.isArray(err?.data?.details)) {
                    setWorkerBonusRuleErrors(err.data.details);
                    toast('Existem conflitos nas faixas informadas.', {
                        type: 'error',
                        autoClose: 3000
                    });
                    return;
                }

                console.log(err);
                Swal({
                    title: 'Erro ao salvar bonificação',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        function getWorkerGroupRolePriority(role) {
            if (role === 'director') return 0;
            if (role === 'manager') return 1;
            return 2;
        }

        function compareWorkersForGroupSort(workerA, workerB) {
            const priorityDifference = getWorkerGroupRolePriority(workerA.role) - getWorkerGroupRolePriority(workerB.role);

            if (priorityDifference !== 0) {
                return priorityDifference;
            }

            const normalizedNameA = (workerA.name || '').trim().toLocaleLowerCase('pt-BR');
            const normalizedNameB = (workerB.name || '').trim().toLocaleLowerCase('pt-BR');
            const nameComparison = normalizedNameA.localeCompare(normalizedNameB, 'pt-BR', { sensitivity: 'base' });

            if (nameComparison !== 0) {
                return nameComparison;
            }

            return Number(workerA.id) - Number(workerB.id);
        }

        function sortWorkerIdsForGroup(workerIds = []) {
            const uniqueWorkerIds = [...new Set(workerIds)];
            const knownWorkers = [];
            const missingWorkerIds = [];

            uniqueWorkerIds.forEach(workerId => {
                const currentWorker = getWorkerById(workerId);

                if (currentWorker) {
                    knownWorkers.push(currentWorker);
                    return;
                }

                missingWorkerIds.push(workerId);
            });

            return knownWorkers
                .sort(compareWorkersForGroupSort)
                .map(currentWorker => currentWorker.id)
                .concat(missingWorkerIds);
        }

        function getWorkerById(workerId) {
            return workers.value.find(currentWorker => currentWorker.id === workerId) || null;
        }

        function getWorkerGroupIds(workerId) {
            return [...(workerGroupMembershipMap.value[workerId] || [])];
        }

        function getEffectiveGroupIds(workerId) {
            const currentGroupIds = getWorkerGroupIds(workerId);

            if (draggedWorkerId.value !== workerId || typeof previewTargetGroupId.value === 'undefined') {
                return currentGroupIds;
            }

            const worker = getWorkerById(workerId);
            if (!worker) {
                return currentGroupIds;
            }

            if (!isMultiGroupRole(worker.role)) {
                return previewTargetGroupId.value === null ? [] : [previewTargetGroupId.value];
            }

            const sourceGroupId = draggedWorkerSourceGroupId.value;
            const targetGroupId = previewTargetGroupId.value;

            if (sourceGroupId === null) {
                if (targetGroupId === null || currentGroupIds.includes(targetGroupId)) {
                    return currentGroupIds;
                }

                return [...currentGroupIds, targetGroupId];
            }

            if (targetGroupId === null) {
                return currentGroupIds.filter(groupId => groupId !== sourceGroupId);
            }

            if (targetGroupId === sourceGroupId || currentGroupIds.includes(targetGroupId)) {
                return currentGroupIds;
            }

            return currentGroupIds
                .filter(groupId => groupId !== sourceGroupId)
                .concat(targetGroupId);
        }

        function isPreviewPlacement(workerId, groupId) {
            return (
                draggedWorkerId.value === workerId &&
                typeof previewTargetGroupId.value !== 'undefined' &&
                previewTargetGroupId.value === groupId
            );
        }

        const workersAvailableForGrouping = computed(() => {
            return workers.value.filter(worker => {
                if (!worker.is_active) {
                    return false;
                }

                if (isMultiGroupRole(worker.role)) {
                    return true;
                }

                return getEffectiveGroupIds(worker.id).length === 0;
            });
        });

        async function init() {
            loading.value = true;
            await loadData();
            loading.value = false;

            await loadWorkers();
            await loadWorkerGroups();
        }

        async function loadData() {
            const routeId = handleRoute(route);
            worker.value = routeId;
            
            await loadStates();

            if (!routeId) {
                isEdit.value = false;
                return;
            }

            isEdit.value = true;
            await getCompanyById(routeId);
            await loadUsers(company.value.id);
            pageHeader.value = `Editar dados de: ${company.value.name}`;
        }
        
        async function loadWorkers(showInactives = null) {
            loadingWorkers.value = true;

            const { data } = await WorkerService.list(company.value.id, showInactives);
            workers.value = sortWorkersHierarchy(data);
            loadingWorkers.value = false;
        }

        async function loadUsers(companyId) {
            try {
                const listingFilter = { page: 1, limit: 9999 };
                const { data } = await UserService.list(listingFilter.page, listingFilter.limit, { company: companyId });

                users.value = data;
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao listar usuários desta empresa',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function loadWorkerGroups() {
            if (!company.value.id) {
                return;
            }

            try {
                loadingWorkerGroups.value = true;
                const { data } = await WorkerGroupService.list(company.value.id);
                workerGroups.value = data.map(group => ({
                    ...group,
                    worker_ids: sortWorkerIdsForGroup(group.worker_ids || [])
                }));
                loadingWorkerGroups.value = false;
            } catch (err) {
                loadingWorkerGroups.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao listar os grupos',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        function sortWorkersHierarchy(workers) {
            const idToWorkerMap = {};
            const roots = [];

            // Criar mapa por ID e adicionar campo temporário `children`
            workers.forEach(worker => {
                idToWorkerMap[worker.id] = { ...worker, children: [] };
            });

            // Organizar subordinados abaixo dos chefes
            workers.forEach(worker => {
                const bossId = worker.boss[0]; // assumindo só 1 chefe
                if (bossId && idToWorkerMap[bossId]) {
                    idToWorkerMap[bossId].children.push(idToWorkerMap[worker.id]);
                } else {
                    roots.push(idToWorkerMap[worker.id]);
                }
            });

            // Ordenar os roots para priorizar os 'director' no topo
            roots.sort((a, b) => {
                if (a.role === 'director' && b.role !== 'director') return -1;
                if (a.role !== 'director' && b.role === 'director') return 1;
                return 0;
            });

            // Achatar a hierarquia (flatten)
            const ordered = [];
            function flatten(worker) {
                ordered.push(worker);
                worker.children.forEach(flatten);
            }

            roots.forEach(flatten);

            // Remover o campo `children` se não quiser ele no resultado
            return ordered.map(({ children, ...rest }) => rest);
        }

        function handleRoute(route) {
             return route.params.id ? +route.params.id : false;
        }

        function normalizePdiParticipationCount(value) {
            const parsed = parseInt(value, 10);

            if (!Number.isInteger(parsed) || parsed < 1) {
                return 1;
            }

            return parsed;
        }

        function increasePdiParticipationCount() {
            company.value.pdi_participation_count = normalizePdiParticipationCount(company.value.pdi_participation_count) + 1;
        }

        function decreasePdiParticipationCount() {
            const currentValue = normalizePdiParticipationCount(company.value.pdi_participation_count);
            company.value.pdi_participation_count = currentValue > 1 ? currentValue - 1 : 1;
        }

        function scrollToSection(sectionId) {
            const element = document.getElementById(sectionId);
            if (!element) return;

            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

        async function getCompanyById(companyId) {
            try {
                const { data } = await CompanyService.getById(companyId);

                if (data && data.state) {
                    data.state = data.state.id;
                }

                if (data && data.city) {
                    await loadCities(data.state);
                    data.city = data.city.id;
                }

                data.pdi_participation_count = normalizePdiParticipationCount(data.pdi_participation_count);

                company.value = data;
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao obter dados do cliente',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function loadStates() {
            try {
                let countryId = 1;
                const { data } = await GeoInfoService.listStates(countryId);

                stateOptions.value = data.map(state => {
                    return {
                        title: state.name,
                        value: state.id
                    }
                });
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao listar os estados',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function loadCities(stateId) {
            try {
                if (!stateId) {
                    return;
                }

                const { data } = await GeoInfoService.listCities(stateId);

                citiesOptions.value = data.map(city => {
                    return {
                        title: city.name,
                        value: city.id
                    }
                });
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao listar as cidades',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function submit() {
            const isValid = await v$.value.$validate();
            if (!isValid) return;

            if (!isEdit.value) {
                await save();
            } else {
                await update();
            }
        }

        async function save() {
            const companyObject = {
                ...company.value,
                country: 1,
                pdi_participation_count: normalizePdiParticipationCount(company.value.pdi_participation_count)
            };
            
            try {
                loading.value = true;
                const { data } = await CompanyService.create(companyObject);
                router.push({ name: 'company', params: { id: data.id } });
                loading.value = false;

                Swal({
                    title: 'Cliente Salvo!',
                    icon: 'success'
                });
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao salvar o cliente',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function update() {
            const companyObject = {
                ...company.value,
                pdi_participation_count: normalizePdiParticipationCount(company.value.pdi_participation_count)
            };
            
            try {
                loading.value = true;
                const { data } = await CompanyService.update(companyObject);
                await getCompanyById(data.id);
                loading.value = false;

                Swal({
                    title: 'Cliente Atualizado!',
                    icon: 'success'
                });
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao atualizar',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        function onUpload(data) {
            const { success } = data;
            const file = success[0];

            company.value.file = file.id;
            company.value.file_url = file.url;
        }

        async function deleteFile() {
            Swal({
                title: 'Tem certeza que deseja remover esse arquivo?',
                text: 'Após remover, é preciso clicar em atualizar',
                icon: 'warning',
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: 'Remover',
                        className: 'swal-button--danger'
                    }
                },
                dangerMode: true
            }).then(async (confirm) => {
                if (confirm) {
                    company.value.file = null;
                    delete company.value.file_url;
                }
            });
        }

        function setModalStatus(status) {
			modalRef.value.setModalStatus(status);
		}

        function setGroupModalStatus(status) {
            groupModalRef.value.setModalStatus(status);

            if (status === 'close') {
                isEditWorkerGroup.value = false;
                editingWorkerGroupId.value = null;
            }
        }

        async function setModalItem(item) {
			isEditWorker.value = true;
            resetWorkerBonusSection();
			worker.value = {
                ...item,
                portal_access: Boolean(item.portal_user && item.portal_user.status)
            };
			setModalStatus('open');
            await loadWorkerBonusRules();
		}

        function addNewWorker() {
            resetWorkerBonusSection();
            setModalStatus('open');
            isEditWorker.value = false;
            worker.value = {
                role: 'worker',
                see_globalpdi: false,
                portal_access: false,
                portal_user: null
            };
        }

        function addNewWorkerGroup() {
            isEditWorkerGroup.value = false;
            editingWorkerGroupId.value = null;
            openGroupActionsId.value = null;
            workerGroupForm.value = {
                name: '',
                color: availableGroupColors[0].value
            };

            setGroupModalStatus('open');
        }

        function toggleGroupActions(groupId) {
            openGroupActionsId.value = openGroupActionsId.value === groupId ? null : groupId;
        }

        function openEditWorkerGroup(group) {
            openGroupActionsId.value = null;
            isEditWorkerGroup.value = true;
            editingWorkerGroupId.value = group.id;
            workerGroupForm.value = {
                name: group.name,
                color: group.color
            };
            setGroupModalStatus('open');
        }

        function setWorkerGroupColor(color) {
            workerGroupForm.value.color = color;
        }

        async function saveWorkerGroup() {
            try {
                if (!workerGroupForm.value.name || !workerGroupForm.value.name.trim()) {
                    Swal({
                        title: 'Informe o nome do grupo',
                        icon: 'info'
                    });
                    return;
                }

                if (!workerGroupForm.value.color) {
                    Swal({
                        title: 'Selecione uma cor para o grupo',
                        icon: 'info'
                    });
                    return;
                }

                loadingCreateWorkerGroup.value = true;

                if (isEditWorkerGroup.value && editingWorkerGroupId.value) {
                    const { data } = await WorkerGroupService.update({
                        id: editingWorkerGroupId.value,
                        company: company.value.id,
                        name: workerGroupForm.value.name,
                        color: workerGroupForm.value.color
                    });

                    workerGroups.value = workerGroups.value.map(group => {
                        if (group.id !== editingWorkerGroupId.value) {
                            return group;
                        }

                        return {
                            ...group,
                            ...data,
                            worker_ids: data.worker_ids || group.worker_ids || []
                        };
                    });
                } else {
                    const { data } = await WorkerGroupService.create({
                        company: company.value.id,
                        name: workerGroupForm.value.name,
                        color: workerGroupForm.value.color
                    });

                    workerGroups.value.push({
                        ...data,
                        worker_ids: data.worker_ids || []
                    });
                }

                loadingCreateWorkerGroup.value = false;
                setGroupModalStatus('close');
            } catch (err) {
                loadingCreateWorkerGroup.value = false;
                const alreadyExists = err?.status === 409 || err?.data?.error === 'already_exists';

                if (alreadyExists) {
                    Swal({
                        title: 'Já existe um grupo com esse nome',
                        text: 'Escolha outro nome',
                        icon: 'info'
                    });
                    return;
                }

                console.log(err);
                Swal({
                    title: `Erro ao ${isEditWorkerGroup.value ? 'atualizar' : 'criar'} grupo`,
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        function deleteWorkerGroup(group) {
            openGroupActionsId.value = null;

            Swal({
                title: `Excluir grupo ${group.name}?`,
                text: 'Os colaboradores voltarão para sem grupo.',
                icon: 'warning',
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: 'Excluir',
                        className: 'swal-button--danger'
                    }
                },
                dangerMode: true
            }).then(async (confirm) => {
                if (!confirm) {
                    return;
                }

                try {
                    loadingDeleteWorkerGroup.value[group.id] = true;
                    await WorkerGroupService.destroy(group.id, company.value.id);
                    workerGroups.value = workerGroups.value.filter(currentGroup => currentGroup.id !== group.id);
                    loadingDeleteWorkerGroup.value[group.id] = false;
                } catch (err) {
                    loadingDeleteWorkerGroup.value[group.id] = false;
                    console.log(err);
                    Swal({
                        title: 'Erro ao excluir grupo',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            });
        }

        function getWorkerRoleStripClass(role) {
            if (role === 'manager') return 'bg-blue-500';
            if (role === 'director') return 'bg-yellow-500';
            return 'bg-green-500';
        }

        function getWorkersByGroup(groupId) {
            const group = workerGroups.value.find(currentGroup => currentGroup.id === groupId);

            if (!group) {
                return [];
            }

            return sortWorkerIdsForGroup(group.worker_ids || [])
                .map(workerId => getWorkerById(workerId))
                .filter(worker => worker && worker.is_active && getEffectiveGroupIds(worker.id).includes(groupId));
        }

        function getWorkerAvailabilityLabel(worker) {
            const groupCount = getWorkerGroupIds(worker.id).length;

            if (isMultiGroupRole(worker.role)) {
                if (!groupCount) {
                    return 'Disponivel para multiplos grupos';
                }

                return `${groupCount} ${groupCount === 1 ? 'grupo' : 'grupos'}`;
            }

            return groupCount ? 'Ja agrupado' : 'Sem grupo';
        }

        function updateWorkerRecord(updatedWorker) {
            const workerIndex = getWorkerIndex(updatedWorker.id);

            if (workerIndex === null) {
                return;
            }

            workers.value.splice(workerIndex, 1, { ...updatedWorker });
        }

        function syncWorkerPortalUser(portalUser) {
            worker.value.portal_user = portalUser ? { ...portalUser } : null;
            worker.value.portal_access = Boolean(portalUser && portalUser.status);

            const workerIndex = getWorkerIndex(worker.value.id);
            if (workerIndex === null) {
                return;
            }

            workers.value.splice(workerIndex, 1, {
                ...workers.value[workerIndex],
                portal_user: portalUser ? { ...portalUser } : null
            });
        }

        function showPortalPasswordMessage(password) {
            if (!password) {
                return;
            }

            Swal({
                title: `Senha: ${password}`,
                text: 'Caso a pessoa não receba esta senha por email, envie a mesma para ela. Esta senha só aparece aqui apenas 1 vez',
                icon: 'success',
                buttons: {
                    confirm: {
                        text: 'Ok!',
                        className: 'swal-button--success'
                    }
                }
            });
        }

        function resetWorkerPortalPassword() {
            if (!worker.value.portal_user?.id) {
                return;
            }

            Swal('Tem certeza que deseja resetar a senha deste usuário?', {
                text: 'Uma vez que resetar a senha, esta pessoa não conseguirá mais entrar com a senha antiga',
                icon: 'warning',
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: 'Resetar agora',
                        className: 'swal-button--danger'
                    }
                },
                dangerMode: true,
            }).then(async (confirm) => {
                if (!confirm) {
                    return;
                }

                try {
                    loadingPortalUserResetPassword.value = true;
                    const { data } = await UserService.resetPassword({
                        id: worker.value.portal_user.id,
                        company: company.value.id
                    });
                    loadingPortalUserResetPassword.value = false;
                    showPortalPasswordMessage(data);
                } catch (err) {
                    loadingPortalUserResetPassword.value = false;
                    console.log(err);
                    Swal({
                        title: 'Erro ao resetar senha',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            });
        }

        function toggleWorkerPortalAccess() {
            if (!worker.value.portal_user?.id) {
                return;
            }

            const nextStatus = !worker.value.portal_user.status;
            const title = nextStatus ? 'Tem certeza que deseja reativar o acesso deste usuário?' : 'Tem certeza que deseja bloquear o acesso deste usuário?';
            const text = nextStatus ? 'Uma vez que reativar, essa pessoa conseguirá fazer login novamente' : 'Uma vez que bloquear, esta pessoa será deslogada e não conseguirá mais entrar';
            const buttonClass = nextStatus ? 'swal-button--success' : 'swal-button--danger';
            const textButton = nextStatus ? 'Reativar' : 'Bloquear Agora';

            Swal({
                title,
                text,
                icon: 'warning',
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: textButton,
                        className: buttonClass
                    }
                }
            }).then(async (confirm) => {
                if (!confirm) {
                    return;
                }

                try {
                    loadingPortalUserToggle.value = true;
                    const { data } = await UserService.toggleStatus(worker.value.portal_user.id, company.value.id);
                    loadingPortalUserToggle.value = false;
                    syncWorkerPortalUser(data);
                    Swal({
                        title: 'Feito!',
                        icon: 'success'
                    });
                } catch (err) {
                    loadingPortalUserToggle.value = false;
                    console.log(err);
                    Swal({
                        title: 'Erro ao atualizar acesso ao portal',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            });
        }

        function onWorkerDragStart(workerId, sourceGroupId = null) {
            draggedWorkerId.value = workerId;
            draggedWorkerSourceGroupId.value = sourceGroupId;
            previewTargetGroupId.value = sourceGroupId;
        }

        function onWorkerDragEnd() {
            clearDragPreviewState();
        }

        function setDragPreviewTarget(groupId) {
            if (!draggedWorkerId.value) {
                return;
            }

            previewTargetGroupId.value = groupId;
        }

        function toggleUngroupedDrawer() {
            isUngroupedDrawerOpen.value = !isUngroupedDrawerOpen.value;
        }

        function onGroupContainerDragOver(_, groupId) {
            if (!draggedWorkerId.value) {
                return;
            }

            previewTargetGroupId.value = groupId;
        }

        function clearDragPreviewState() {
            draggedWorkerId.value = null;
            draggedWorkerSourceGroupId.value = null;
            previewTargetGroupId.value = undefined;
        }

        function showDuplicateWorkerGroupMessage(workerName, groupName) {
            Swal({
                title: 'Colaborador ja esta neste grupo',
                text: `${workerName} ja faz parte de ${groupName}.`,
                icon: 'info'
            });
        }

        function buildNextWorkerGroupsState(workerId, workerRole, sourceGroupId, targetGroupId) {
            const normalizedSourceGroupId = sourceGroupId || null;
            const normalizedTargetGroupId = targetGroupId || null;

            if (!isMultiGroupRole(workerRole)) {
                return workerGroups.value.map(group => {
                    const workerIds = (group.worker_ids || []).filter(id => id !== workerId);

                    if (normalizedTargetGroupId && group.id === normalizedTargetGroupId) {
                        workerIds.push(workerId);
                    }

                    return {
                        ...group,
                        worker_ids: sortWorkerIdsForGroup(workerIds)
                    };
                });
            }

            return workerGroups.value.map(group => {
                let workerIds = [...(group.worker_ids || [])];

                if (normalizedSourceGroupId && group.id === normalizedSourceGroupId) {
                    workerIds = workerIds.filter(id => id !== workerId);
                }

                if (normalizedTargetGroupId && group.id === normalizedTargetGroupId && !workerIds.includes(workerId)) {
                    workerIds.push(workerId);
                }

                return {
                    ...group,
                    worker_ids: sortWorkerIdsForGroup(workerIds)
                };
            });
        }

        function assignWorkerToGroup(workerId, targetGroupId) {
            const worker = getWorkerById(workerId);
            const sourceGroupId = draggedWorkerSourceGroupId.value || null;
            const normalizedTargetGroupId = targetGroupId || null;
            const currentGroupIds = getWorkerGroupIds(workerId);

            if (!worker) {
                return;
            }

            if (!isMultiGroupRole(worker.role) && currentGroupIds.length === 1 && currentGroupIds[0] === normalizedTargetGroupId) {
                onWorkerDragEnd();
                return;
            }

            if (isMultiGroupRole(worker.role)) {
                if (sourceGroupId === null && normalizedTargetGroupId === null) {
                    onWorkerDragEnd();
                    return;
                }

                if (sourceGroupId === normalizedTargetGroupId) {
                    onWorkerDragEnd();
                    return;
                }

                if (normalizedTargetGroupId !== null && currentGroupIds.includes(normalizedTargetGroupId)) {
                    const targetGroup = workerGroups.value.find(group => group.id === normalizedTargetGroupId);
                    onWorkerDragEnd();
                    showDuplicateWorkerGroupMessage(worker.name, targetGroup?.name || 'este grupo');
                    return;
                }
            }

            const previousGroupsState = workerGroups.value.map(group => ({
                ...group,
                worker_ids: [...(group.worker_ids || [])]
            }));

            loadingAssignWorkerGroup.value[workerId] = true;
            clearDragPreviewState();

            // UX otimista: move o card imediatamente e confirma no backend em background.
            workerGroups.value = buildNextWorkerGroupsState(
                workerId,
                worker.role,
                sourceGroupId,
                normalizedTargetGroupId
            );

            WorkerGroupService.assignWorker(company.value.id, workerId, normalizedTargetGroupId, sourceGroupId)
                .then(() => {
                    loadingAssignWorkerGroup.value[workerId] = false;
                })
                .catch((err) => {
                    workerGroups.value = previousGroupsState;
                    loadingAssignWorkerGroup.value[workerId] = false;

                    if (err?.status === 409 || err?.data?.error === 'already_member') {
                        const targetGroup = workerGroups.value.find(group => group.id === normalizedTargetGroupId);
                        showDuplicateWorkerGroupMessage(worker.name, targetGroup?.name || 'este grupo');
                        return;
                    }

                    console.log(err);
                    Swal({
                        title: 'Erro ao atualizar agrupamento',
                        text: 'Tente novamente',
                        icon: 'error'
                    });
                });
        }

        function onDropWorkerOnGroup(groupId) {
            if (!draggedWorkerId.value) {
                return;
            }

            previewTargetGroupId.value = groupId;
            assignWorkerToGroup(draggedWorkerId.value, groupId);
        }

        function onDropWorkerWithoutGroup() {
            if (!draggedWorkerId.value) {
                return;
            }

            previewTargetGroupId.value = null;
            assignWorkerToGroup(draggedWorkerId.value, null);
        }

        function getWorkerIndex(workerId) {
            for (let [index, worker] of workers.value.entries()) {
                if (worker.id === workerId) {
                    return index;
                }
            }

            return null;
        }

        async function submitWorker() {
            try {
                worker.value.company = company.value.id;
                
                if (!worker.value.name) {
                    Swal({
                        title: 'O campo de nome é obrigatório',
                        text: 'O nome não pode ficar em branco',
                        icon: 'info'
                    });
                    return;
                }

                if (worker.value.portal_access && !worker.value.email) {
                    Swal({
                        title: 'Informe um email para acesso ao portal',
                        text: 'O colaborador precisa ter email para acessar o portal do cliente',
                        icon: 'info'
                    });
                    return;
                }
                
                if (isEditWorker.value) {
                    loadingSubmitWorker.value = true;

                    const { data } = await WorkerService.update(worker.value);
                    updateWorkerRecord(data);
                    setModalStatus('close');
                    loadingSubmitWorker.value = false;
                    showPortalPasswordMessage(data.portal_access_password);
                } else {
                    loadingSubmitWorker.value = true;
                    const { data } = await WorkerService.create(worker.value);
                    workers.value.push(data);
                    setModalStatus('close');
                    loadingSubmitWorker.value = false;
                    showPortalPasswordMessage(data.portal_access_password);
                }
            } catch(err) {
                console.log(err);
                loadingSubmitWorker.value = false;

				if (err?.data?.error === 'portal_access_requires_email') {
					Swal({
						title: 'Informe um email para acesso ao portal',
						text: 'O colaborador precisa ter email para acessar o portal do cliente',
						icon: 'info'
					});
					return;
				}

				const emailAlreadyExists = err?.data?.error === 'already_exists'
					|| err?.data?.error === 'already_exist'
					|| err?.data === 'already_exist';

				if (emailAlreadyExists) {
					Swal({
						title: 'Já existe uma pessoa com este Email',
						text: 'Use outro email',
						icon: 'info'
					});
					return;
				}

                Swal({
                    title: 'Ocorreu um erro',
                    text: 'Atualize a página e tente novamente, se o erro persistir, entre em contato',
                    icon: 'error'
                });
            }
        }

        function hasAnyWorkerSelected() {
            let hasTrue = false;

            for (let worker in selectedWorkers.value) {
                console.log(selectedWorkers.value[worker])
                if (selectedWorkers.value[worker]) {
                    hasTrue = true;
                    break;
                }
            }

            return hasTrue;
        }
        
        function activateMarkTeam(bossId) {
            selectedBossId.value = bossId;
            selectedWorkers.value = {};
            showWorkersCheckBox.value = true;
        }

        function cancelMarkTeam() {
            selectedBossId.value = null;
            selectedWorkers.value = {};
            showWorkersCheckBox.value = false;
        }

        async function linkBoss() {
            loadingConfirmLinkBoss.value = true;
            const workersIds = Object.keys(selectedWorkers.value).map(Number);

            const { data } = await WorkerService.linkBoss(selectedBossId.value, workersIds, company.value.id);
            selectedBossId.value = null;
            selectedWorkers.value = [];
            showWorkersCheckBox.value = false;
            loadingConfirmLinkBoss.value = false;
            await loadWorkers();
        }

        async function toggleWorkerStatus(workerId) {
            loadingToggleWorkerStatus.value[workerId] = true;
            const { data } = await WorkerService.toggleIsActive(workerId, company.value.id);
            const updatedWorkerIndex = getWorkerIndex(data.id);
            workers.value.splice(updatedWorkerIndex, 1, data);

            loadingToggleWorkerStatus.value[workerId] = false;
        }

        async function removeFromBoss(worker) {
            if (loadingRemoveFromBoss.value[worker.id]) {
                return;
            }

            loadingRemoveFromBoss.value[worker.id] = true;

            const bossId = findClosestBossId(worker.id);
            const workersIds = [worker.id];
            const { data } = await WorkerService.linkBoss(bossId, workersIds, company.value.id);
            const indexOfBoss = worker.boss.indexOf(bossId);
            worker.boss.splice(indexOfBoss, 1);

            loadingRemoveFromBoss.value[worker.id] = false;
        }

        function bossHasBoss(workerId) {
            const bossId = findClosestBossId(workerId);
            const superiorBossId = findClosestBossId(bossId);

            return superiorBossId ? true : false;
        }

        function findClosestBossId(workerId) {
            const index = workers.value.findIndex(w => w.id === workerId);
            if (index === -1) return null;

            const target = workers.value[index];
            const bossIds = target.boss || [];
            if (bossIds.length === 0) return null;

            for (let i = index - 1; i >= 0; i--) {
                if (bossIds.includes(workers.value[i].id)) {
                    return workers.value[i].id;
                }
            }

            return null;
        }

        async function toggleShowInactiveWorkers(show) {
            await loadWorkers(show);
        }

        watch(() => route.params, async (to, from) => {
            if (route.name == 'company' && (from != to)) {
                await init();
            }
        }, { deep: true });

        watch(workerBonusRules, () => {
            validateWorkerBonusRules();
        }, { deep: true });

        watch(savingWorkerBonusRules, isSaving => {
            if (workerBonusSaveLoadingDotsInterval) {
                clearInterval(workerBonusSaveLoadingDotsInterval);
                workerBonusSaveLoadingDotsInterval = null;
            }

            if (!isSaving || !applyWorkerBonusToAllWorkers.value) {
                workerBonusSaveLoadingDots.value = '.';
                return;
            }

            workerBonusSaveLoadingDots.value = '.';
            workerBonusSaveLoadingDotsInterval = setInterval(() => {
                workerBonusSaveLoadingDots.value = workerBonusSaveLoadingDots.value === '...'
                    ? '.'
                    : `${workerBonusSaveLoadingDots.value}.`;
            }, 450);
        });

        watch(applyWorkerBonusToAllWorkers, isEnabled => {
            if (isEnabled || !workerBonusSaveLoadingDotsInterval) {
                return;
            }

            clearInterval(workerBonusSaveLoadingDotsInterval);
            workerBonusSaveLoadingDotsInterval = null;
            workerBonusSaveLoadingDots.value = '.';
        });

        onBeforeUnmount(() => {
            if (!workerBonusSaveLoadingDotsInterval) {
                return;
            }

            clearInterval(workerBonusSaveLoadingDotsInterval);
        });

        init();
        const v$ = useVuelidate(rules, company);

        return {
            workerModalTitle,
            workerBonusCompetenceDate,
            workerBonusRules,
            workerBonusRuleErrors,
            loadingWorkerBonusRules,
            savingWorkerBonusRules,
            applyWorkerBonusToAllMonths,
            applyWorkerBonusToAllWorkers,
            workerBonusSaveLoadingDots,
            workerBonusSimulationCompetenceDate,
            workerBonusSimulationScore,
            workerBonusSimulationAmountLabel,
            workerBonusSimulationDescription,
            onChangeWorkerBonusCompetence,
            onChangeWorkerBonusSimulationCompetence,
            saveWorkerBonusRules,
            addWorkerBonusRule,
            removeWorkerBonusRule,
            getWorkerBonusRuleError,
            onDropWorkerWithoutGroup,
            onDropWorkerOnGroup,
            onGroupContainerDragOver,
            setDragPreviewTarget,
            isPreviewPlacement,
            onWorkerDragEnd,
            onWorkerDragStart,
            getWorkersByGroup,
            getWorkerAvailabilityLabel,
            getWorkerRoleStripClass,
            deleteWorkerGroup,
            openEditWorkerGroup,
            toggleGroupActions,
            saveWorkerGroup,
            loadingCreateWorkerGroup,
            setWorkerGroupColor,
            addNewWorkerGroup,
            setGroupModalStatus,
            isEditWorkerGroup,
            openGroupActionsId,
            workerGroupForm,
            availableGroupColors,
            groupModalRef,
            loadingAssignWorkerGroup,
            loadingDeleteWorkerGroup,
            isUngroupedDrawerOpen,
            workersAvailableForGrouping,
            workerGroups,
            loadingWorkerGroups,
            toggleUngroupedDrawer,
            bossHasBoss,
            searchWorker,
            filteredWorkers,
            loadingConfirmLinkBoss,
            removeFromBoss,
            loadingRemoveFromBoss,
            loadingToggleWorkerStatus,
            loadingPortalUserToggle,
            loadingPortalUserResetPassword,
            toggleWorkerPortalAccess,
            resetWorkerPortalPassword,
            toggleWorkerStatus,
            loadWorkerGroups,
            loadWorkers,
            loadingWorkers,
            loadingSubmitWorker,
            showInactiveWorkers,
            toggleShowInactiveWorkers,
            selectedBossId,
            hasAnyWorkerSelected,
            linkBoss,
            cancelMarkTeam,
            showWorkersCheckBox,
            activateMarkTeam,
            selectedWorkers,
            submitWorker,
            addNewWorker,
            setModalItem,
            isEditWorker,
            setModalStatus,
            deleteFile,
            onUpload,
            loadCities,
            increasePdiParticipationCount,
            decreasePdiParticipationCount,
            scrollToSection,
            pageHeader,
            company,
            loading,
            MaskService,
            stateOptions,
            citiesOptions,
            isEdit,
            v$,
            users,
            submit,
            save,
            update,
            workers,
            worker,
            roleOptions,
            modalRef
        }
    },
}
</script>

<style scoped>
.company-main-card :deep(.card) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.company-workers-card :deep(.card) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.company-workers-table {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: -1px;
}

.company-form-grid :deep(.form-row) {
    margin-top: 0.75rem;
    margin-bottom: 1rem;
}

.company-anchor-button {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 9999px;
    color: #166534;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1;
    padding: 0.5rem 0.75rem;
    text-transform: uppercase;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.company-anchor-button:hover {
    background: #dcfce7;
    border-color: #86efac;
    color: #14532d;
}
</style>
